module.exports = __webpack_public_path__ + "img/true_icon.17cd9560.png";